import { supabase } from '@/lib/supabase'

export type CommunityMentionUserProfile = {
  id: string
  full_name: string
  avatar_url: string | null
}

function normalizeIds(userIds: string[]): string[] {
  const set = new Set<string>()
  for (const id of userIds || []) {
    const value = String(id || '').trim()
    if (value) set.add(value)
  }
  return Array.from(set)
}

function toUserProfile(row: any): CommunityMentionUserProfile | null {
  const id = String(row?.id || '').trim()
  if (!id) return null
  const full_name = String(row?.full_name || '').trim() || 'Usuário'
  const avatar_url = row?.avatar_url ? String(row.avatar_url) : null
  return { id, full_name, avatar_url }
}

export async function fetchCommunityMentionUsersByIds(
  userIds: string[],
): Promise<CommunityMentionUserProfile[]> {
  const ids = normalizeIds(userIds)
  if (ids.length === 0) return []

  try {
    const { data, error } = await supabase.rpc('get_mention_users_by_ids', {
      p_user_ids: ids,
    } as any)
    if (!error) {
      return ((data as any[]) || [])
        .map(toUserProfile)
        .filter(Boolean) as CommunityMentionUserProfile[]
    }
  } catch {
    // ignore and fallback
  }

  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('id, full_name, avatar_url')
      .in('id', ids as any)
    if (error) throw error
    return ((data as any[]) || [])
      .map(toUserProfile)
      .filter(Boolean) as CommunityMentionUserProfile[]
  } catch {
    return []
  }
}

